import { render, staticRenderFns } from "./ImportantReminder.vue?vue&type=template&id=2a4ad27e&scoped=true&"
import script from "./ImportantReminder.vue?vue&type=script&lang=js&"
export * from "./ImportantReminder.vue?vue&type=script&lang=js&"
import style0 from "./ImportantReminder.vue?vue&type=style&index=0&id=2a4ad27e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ad27e",
  null
  
)

export default component.exports